import React from 'react';
import {Modal} from 'react-bootstrap';
import './ClinicalFlowEditModal.css';

export default function ClinicalFlowEditModal({title, onClose, disabled, children, actions}) {
 return <Modal show centered scrollable className="clinical-edit-modal" onHide={() => !disabled && onClose()} aria-label={title}>
  <Modal.Header closeButton={!disabled} closeLabel="Fechar edição">
   <div className="clinical-edit-heading">
    <span className="clinical-edit-icon" aria-hidden="true">
     <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9M16.5 3.5a2.12 2.12 0 0 1 3 3L9 17l-4 1 1-4Z"/></svg>
    </span>
    <div><span className="clinical-edit-eyebrow">ASSISTENTE DA CLÍNICA</span><Modal.Title as="h5">{title}</Modal.Title></div>
   </div>
  </Modal.Header>
  <Modal.Body className="clinical-flow-modal-fields">
   <p className="clinical-edit-intro">Ajuste esta etapa para deixar o atendimento com a identidade da sua clínica.</p>
   {children}
  </Modal.Body>
  <Modal.Footer>
   <span className="clinical-edit-draft"><span aria-hidden="true" />Edição do rascunho</span>
   <div className="clinical-edit-actions">{actions}</div>
  </Modal.Footer>
 </Modal>;
}
